import { Layout as AntdLayout } from 'antd';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { CustomSidebar } from '../CustomSidebar/CustomSidebar';

const { Content } = AntdLayout;

const StyledLayout = styled(AntdLayout)`
  height: 100vh;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 30px;
`;

const ContentContainer = styled(Content)`
  background-color: #f2f2f2;
`;

/**
 * Layout with a sidebar and content area
 */
export const Layout = props => {
  return (
    <AntdLayout>
      <CustomSidebar />
      <StyledLayout>
        <ContentContainer>{props.children}</ContentContainer>
      </StyledLayout>
    </AntdLayout>
  );
};

Layout.propTypes = {
  /**
   * HTML elements or React nodes
   */
  children: PropTypes.node
};
